<template>
  <div>
    <titulo-lancamentos-nf />
    <filtro-lancamentos-nf @filtrar="getNotasFiltradas" />
    <tabela-lancamentos-nf :items="items" @atualizar="getNotasFiltradas" @alterar-ordenacao="novaOrdenacao"/>
    <paginacao
      v-model="paginacao"
      :total="paginacao.total"
      @input="getNotasFiltradas"
    />
  </div>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import breadcrumb from '@/common/utils/breadcrumb';
import mensagem from '@/common/utils/mensagem';
// Services:
import NotaFiscalService from '@/common/services/nota-fiscal/nota-fiscal.service.js';

// Components:
import TituloLancamentosNf from '@/views/suprimentos/lancamentos-nf/components/TituloLancamentosNF';
import TabelaLancamentosNf from './components/Tabela';
import FiltroLancamentosNf from './components/filtro/Index';
import Paginacao from '@/components/paginacao/Paginacao';

export default {
  components: {
    TituloLancamentosNf,
    FiltroLancamentosNf,
    TabelaLancamentosNf,
    Paginacao,
  },
  mounted() {
    breadcrumb.definir(this.$store, [
      { titulo: this.$t('SUPRIMENTOS.SUPRIMENTOS') },
      { titulo: this.$t('SUPRIMENTOS.LANCAMENTOS_NF') },
    ]);
  },
  data() {
    return {
      filtrandoPor: {},
      items: [],
      paginacao: {
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
        total: 0,
      },
      campoOrdenado: null,
      ordem: false,
    };
  },
  methods: {
    cadastrar() {
      this.$router.push({ name: 'criar-nf' })
    },
    getNotasFiltradas(filtro) {
      filtro ? (this.filtrandoPor = filtro) : (filtro = this.filtrandoPor);

      let param = {
        NumeroDaPagina: this.paginacao.numeroDaPagina,
        TamanhoDaPagina: this.paginacao.tamanhoDaPagina,
        CampoOrdenado :this.campoOrdenado, 
        OrdenacaoAscendente:this.ordem,
        DataEmissaoInicio: this.filtrandoPor.dataEmissaoInicio,
        DataEmissaoAte: this.filtrandoPor.dataEmissaoAte,
        DataVencimentoInicio: this.filtrandoPor.dataVencimentoInicio,
        DataVencimentoAte: this.filtrandoPor.dataVencimentoAte,
        NumeroNotaFiscal: this.filtrandoPor.numeroNotaFiscal
      }

      this.$store.dispatch(START_LOADING);
      NotaFiscalService.obterPorFiltro(param)
        .then(({ data }) => {
          this.items = data.itens;
          this.paginacao.total = data.paginacao.totalDeElementos;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    novaOrdenacao(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = !ordem;
      this.getNotasFiltradas(); 
    },
  },
};
</script>
